module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(this.section) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.pretty_name),
      expression: "section.pretty_name"
    }],
    staticClass: "form-input input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.section.pretty_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.section, "pretty_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm input-group-btn",
    on: {
      "click": function($event) {
        _vm.hidden = !_vm.hidden
      }
    }
  }, [_c('i', {
    staticClass: "icon",
    class: {
      'icon-arrow-down': _vm.hidden, 'icon-arrow-up': !_vm.hidden
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm input-group-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('delete')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-delete"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm input-group-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('moveUp')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-upward"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm input-group-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('moveDown')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-downward"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidden),
      expression: "!hidden"
    }],
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.name),
      expression: "section.name"
    }],
    staticClass: "form-input input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.section.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.section, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.section.display),
      expression: "section.display"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.section.display) ? _vm._i(_vm.section.display, null) > -1 : (_vm.section.display)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.section.display,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.section, "display", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.section, "display", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.section, "display", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12 innerInput"
  }, [_vm._l((_vm.section.fields), function(field, i) {
    return _c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.name),
        expression: "field.name"
      }],
      staticClass: "form-input input-sm",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (field.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(field, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.tag),
        expression: "field.tag"
      }],
      staticClass: "form-input input-sm",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (field.tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(field, "tag", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm input-group-btn",
      on: {
        "click": function($event) {
          return _vm.removeField(i)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-minus"
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-special",
    on: {
      "click": function($event) {
        return _vm.section.fields.push({
          name: 'name',
          tag: '{{tag}}'
        })
      }
    }
  }, [_vm._v("\n                Add "), _c('i', {
    staticClass: "icon icon-plus"
  })])], 2)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Name in template")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Display by default")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n              Fields\n              \n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35e6e16e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/templateSection.vue
// module id = 488
// module chunks = 1